import { render } from "./SalesPersonHomeDetails.vue?vue&type=template&id=5aa442ba"
import script from "./SalesPersonHomeDetails.vue?vue&type=script&lang=js"
export * from "./SalesPersonHomeDetails.vue?vue&type=script&lang=js"

import "./SalesPersonHomeDetails.vue?vue&type=style&index=0&id=5aa442ba&scoper=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__